module.exports = __webpack_public_path__ + "img/intro_video_text_bottom.b423165b.png";